import { render, staticRenderFns } from "./EditScanningTask.vue?vue&type=template&id=6c793d6c&"
import script from "./EditScanningTask.vue?vue&type=script&lang=js&"
export * from "./EditScanningTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports